import $http from '../../axios-instance';
import Swal from 'sweetalert2';
import { validarPermisoComponente } from "@/plugins/acl";
import { getAcls } from '@/plugins/acl';

export async function listarEmpresas({state, commit}) {

    const parametros = {
        params: state.filtro
    };

    commit('dashboard/load', true, {root: true});

    await $http.get('/companies/list', parametros)
        .then((response) => {
            commit('setListarEmpresas', response.data.data);
            commit('cargarEmpresas', response.data.data.data);
        })
        .catch((error) => {
        });

    commit('dashboard/load', false, {root: true});
}

export async function guardaEmpresa({commit, state, dispatch}) {
    commit('dashboard/load', true, {root: true});

    const acls = getAcls();
    if (acls && acls.uuid){
        Object.assign(state.selectedEmpresa, {uuid: acls.uuid})
    }
    await $http.post('/companies/create', state.selectedEmpresa)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: true
            });
            commit('resetSelectedEmpresa',{root: true});
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            const responseData = error.errors
            Object.keys(responseData).forEach((key) => {
                const errorMessage = responseData[key]
                if (errorMessage) {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: errorMessage,
                    showConfirmButton: true
                });
                }
            })
        });

}

export async function actualizarEmpresa({commit, state, dispatch}, id_empresa) {
    commit('dashboard/load', true, {root: true});
    await $http.put(`/companies/update/${id_empresa}`, state.selectedEmpresa)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: true
            });
            state.error = false;
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            const responseData = error.errors
            Object.keys(responseData).forEach((key) => {
                const errorMessage = responseData[key]
                if (errorMessage) {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: errorMessage,
                    showConfirmButton: true
                });
                }
            })
        });

}

export async function guardaUsuario({commit, state, rootState, dispatch}) {

    commit('dashboard/load', true, {root: true});

    await $http.post('/usuarios/crear', state.selectedUsuario)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            commit('establecerModalUsuario', false);
            this.$vue.$alertSuccess(response.data.message)
            await dispatch('getUsuarios', rootState.empresa.selectedEmpresa.id);
            await dispatch('getUsuario', response.data.usuario.id);
        })
        .catch((error) => {

            commit('dashboard/load', false, {root: true});

            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br />' + error.errors,
                showConfirmButton: true
            });
        });
}

export async function getRoles({commit, state}) {

        commit('dashboard/load', true, {root: true});
        await $http.get('/acl-roles',{ params: {company_id : state.users.id_empresa }})
            .then((response) => {
                commit('dashboard/load', false, {root: true});
                commit('setRoles', response.data.data);
                state.error = false;
            })
            .catch((error) => {
                commit('dashboard/load', false, {root: true});
                commit('rolesError', error.message);
            });

}


export async function datosEmpresa({commit, state}, id) {
    if (!isNaN(id)) {
        commit('dashboard/load', true, {root: true});
    await $http.get(`/companies/show/${id}`)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setDatosEmpresa', response.data.data);
            commit('home/establecerEmpresa', response.data.data, {root: true});
            state.error = false;
            return response.data.data;
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            commit('empresaDatosError', error.message);
        });
    }


}

export async function getHistorico({commit, state}, id) {
    if (id !== undefined) {
        await $http.post(`/empresas/historicos_soluquim/${id}`)
            .then((response) => {
                commit('setListadoHistorico', response.data);
                state.error = false;
            })
            .catch((error) => {
                commit('historicoListadoError', error.message);
            });
    }
}

export async function getDiligenciados({commit, state, dispatch}, id) {
    commit('dashboard/load', true, {root: true});
    await $http.get(`empresas/productos_diligenciados/ver/${id}`)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setDiligenciados', response.data);
            state.error = false;
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            commit('diligenciadosError', error.message);
        });
}

export async function guardaMensaje({commit, state, rootState}) {
    commit('dashboard/load', true, {root: true});
    let empresa = rootState.empresa.selectedEmpresa.id;
    await $http.post(`empresas/mensaje/${empresa}`, state.selectedMensaje)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = false;
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error.message,
                showConfirmButton: false,
                timer: 2000
            });
        });
}

export async function guardaDiseno({commit, state, rootState}) {

    commit('dashboard/load', true, {root: true});
    state.selectedDiseno.id_empresa = rootState.empresa.selectedEmpresa.id;

    await $http.post('empresas/diseno', state.selectedDiseno)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = false;
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error.message,
                showConfirmButton: false,
                timer: 2000
            });
        });
}

export async function getUsuarios({commit, state}) {

    commit('dashboard/load', true, {root: true});

    await $http.post('/usuarios', state.users)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setListadoUsuario', response.data);
            state.error = false;
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            commit('usuarioListadoError', error.message);
        });
}

export async function exportarUsuarios({commit, state}, id) {
    commit('dashboard/load', true, {root: true});
    await $http({
        url: `/usuarios/exportar/${id}`,
        method: 'POST',
        responseType: 'blob'
    })
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            let nombreEmpresa = sanitizarString(state.selectedEmpresa.nombre);
            window.downloadFile(response.data, nombreEmpresa, '.xlsx')
        })
        .catch(async (error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: 'Error al exportar los usuarios de la generales',
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export const sanitizarString = (texto) => {
    texto = texto.trim();

    texto = texto.replace(/ /g, '-');
    texto = texto.toLocaleLowerCase();

    texto = texto.replace(/[áàäâªÁÀÂÄ]/g, 'a');
    texto = texto.replace(/[éèëêÉÈÊË]/g, 'e');
    texto = texto.replace(/[íìïîÍÌÏÎ]/g, 'i');
    texto = texto.replace(/[óòöôõÓÒÖÔ]/g, 'o');
    texto = texto.replace(/[úùüûÚÙÛÜ]/g, 'u');

    texto = texto.replace(/[ñÑ]/g, 'n');
    texto = texto.replace(/[çÇ]/g, 'c');

    texto = texto.replace(/[\\¨º~*#@|!\,·$%&/()?'¡¿[^<>+}{¨´><;:.\]]/g, '');
    texto = texto.replace(/--/g, '-');

    return texto;
};

export async function getUsuario({commit, state, dispatch, rootState}, id) {
    if (id !== undefined) {
        commit('dashboard/load', true, {root: true});
        await $http.get(`/usuarios/ver/${id}`)
            .then(async (response) => {
                commit('establecerSelectedUsuario', response.data.data);
                commit('setRolUsuario', response.data.data);
                await dispatch('getPermisosPorRol', {id_rol: response.data.rolusuario, usuario: true});
                commit('dashboard/load', false, {root: true});
            })
            .catch((error) => {
                commit('dashboard/load', false, {root: true});
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: error.message + '<br> ' + error.errors,
                    showConfirmButton: true,
                    timer: 3000
                });
            });
    }
}

export async function getDiseno({commit, state}, id) {
    if (id !== undefined) {
        commit('dashboard/load', true, {root: true});
        await $http.get(`/empresas/diseno/ver/${id}`)
            .then((response) => {
                commit('dashboard/load', false, {root: true});
                commit('setDiseno', response.data);
                state.error = false;
            })
            .catch((error) => {
                commit('dashboard/load', false, {root: true});
                commit('disenoError', error.message);
            });
    }
}

export async function getMensaje({commit, state}, id) {
    if (id !== undefined) {
        commit('dashboard/load', true, {root: true});
        await $http.get(`/empresas/mensaje/ver/${id}`)
            .then((response) => {
                commit('dashboard/load', false, {root: true});
                if (response.data['mensajeet'] != '') {
                    commit('getMensaje', response.data);
                }
                state.error = false;
            })
            .catch((error) => {
                commit('dashboard/load', false, {root: true});
                commit('getMensajeError', error.message);
            });
    }
}

//funcion para listar las empresas con un select y con escritura
export async function getEmpresaFiltro({commit, state},name) {
    commit('dashboard/load', true, {root: true});
    await $http.get(`/empresas/lista`,{params: { nombre: name}})
        .then((response) => {
            commit('setListaEmpresa', response.data);
            state.error = false;
        })
        .catch((error) => {
            commit('mensajeError', error.message);
        }).finally(() => {
            commit('dashboard/load', false, {root: true});
        });
}

export async function getImagen({ commit, state }, { companyId, module }) {

    let contratista = state.contratista;
    if (!companyId) companyId = state.selectedEmpresa.id;

    commit('dashboard/load', true, {root: true});

    await $http.get(`empresas/imagen/ver/${companyId}/${contratista}?module=${module}`)
        .then((response) => {
            
            const myCompanyId = localStorage.getItem('my_company')
            if (myCompanyId && myCompanyId == companyId) {
                commit('setSelectedImagenCurrentCompany', response.data.data);
            } 

            commit('getImagenLogo', response.data.data);

            state.error = false;
            state.imagenCargada = true;
            commit('dashboard/load', false, {root: true});
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            commit('imagenLogoError', error.message);
        });

}

export async function guardaDiligenciados({state, rootState}) {

    state.selectedResumenRpq.id_empresa = rootState.empresa.selectedEmpresa.id;

    await $http.post(`empresas/productos_diligenciados/crear`, state.selectedResumenRpq)
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = false;
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                showConfirmButton: false,
                timer: 2000
            });
        });
}

export async function guardaActualizaCampoPersonalizado({commit, state, dispatch}) {
    if (state.selectedCamposPersonalizados.editar) {
        dispatch('actualizaCamposPersonalizado');
    } else {
        dispatch('guardaCampoPersonalizado');
    }
}

export async function guardaCampoPersonalizado({commit, state, rootState, dispatch}) {

    state.selectedCamposPersonalizados.id_empresa = rootState.empresa.selectedEmpresa.id;
    commit('dashboard/load', true, {root: true});
    await $http.post(`empresas/campos_personalizados/crear/${state.selectedEmpresa.id}`, state.selectedCamposPersonalizados)
        .then(async (response) => {
            commit('establecerModalCamposPersonalizados', false);
            commit('dashboard/load', false, {root: true});
            await Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            dispatch('getCamposPersonalizado');
            state.error = false;
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error.message,
                showConfirmButton: false,
                timer: 2000
            });
        });
}

/**
 * Cambiar estado imagen
 */
export async function cambiarEstado({commit, state, dispatch}) {

    await Swal.fire({
        title: 'Cambiar estado',
        text: '¿Está seguro de cambiar el estado del campo personalizado?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Si'
    }).then(async (result) => {
        if (result.value) {
            await dispatch('actualizaCamposPersonalizado');
        }
    });
}

/**
 * @param  {} {commit
 * @param  {} state
 * @param  {} rootState}
 */
export async function getCamposPersonalizado({commit, state, rootState}) {

    commit('dashboard/load', true, {root: true});
    state.selectedCamposPersonalizados.id_empresa = rootState.empresa.selectedEmpresa.id;

    await $http.get(`empresas/campos_personalizados/${state.selectedEmpresa.id}`)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setListadoCamposPersonalizados', response.data.data);
            state.error = false;
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            commit('listadocampopersonalizadosError', error.message);
        });
}

/**
 * @param  {} {commit
 * @param  {} state
 * @param  {} rootState}
 */
export async function actualizaCamposPersonalizado({commit, state, rootState, dispatch}) {

    state.selectedCamposPersonalizados.id_empresa = rootState.empresa.selectedEmpresa.id;

    commit('dashboard/load', true, {root: true});
    await $http.put(`empresas/campos_personalizados/editar/${state.selectedEmpresa.id}`, state.selectedCamposPersonalizados)
        .then(async (response) => {
            commit('establecerModalCamposPersonalizados', false);
            commit('dashboard/load', false, {root: true});
            await Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });

            dispatch('getCamposPersonalizado');
            dispatch('cambiaEditar', false);
            state.error = false;
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.errors,
                showConfirmButton: false,
                timer: 2000
            });
        });
}

/**
 * @param  {} {commit
 * @param  {} state}
 * @param  {} datos
 */
export function cambiaEditar({commit, state}, datos) {
    if (datos === false) {
        state.selectedCamposPersonalizados = {
            nombre: '',
            activo: 1,
            editar: false,
            stbutton: 'success',
            button: 'Crear',
            titulo: 'Crear Campo Personalizado'
        };

    } else {
        state.selectedCamposPersonalizados = datos;
        state.selectedCamposPersonalizados.editar = true;
        state.selectedCamposPersonalizados.button = 'Editar';
        state.selectedCamposPersonalizados.stbutton = 'primary';
        state.selectedCamposPersonalizados.titulo = 'Editar Campo Personalizado';
    }
}

/**
 * @param  {} {commit
 * @param  {} state
 * @param  {} rootState
 * @param  {} dispatch}
 * @param  {} data
 */
export async function guardaImage({commit, state, rootState, dispatch}, data) {
    data.append('id_empresa', rootState.empresa.selectedEmpresa.id);
    data.append('orientacion', rootState.empresa.selectedImagen.orientacion);
    data.append('contratista', rootState.empresa.contratista);

    commit('dashboard/load', true, {root: true});

    let companyId = 'id_empresa' in data ? data.id_empresa : rootState.empresa.selectedEmpresa.id;

    if (rootState.empresa.contratista === 0) {
        await $http.post(`empresas/imagen/adjuntar`, data)
            .then((response) => {
                commit('dashboard/load', false, {root: true});
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Muy bien!',
                    text: response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                });
                dispatch('getImagen', {
                    companyId,
                    module: 'COMPANY'
                });
                state.error = false;
            })
            .catch((error) => {
                commit('dashboard/load', false, {root: true});
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Error',
                    text: response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                });
            });
    } else {
        await $http.post(`empresas/imagen/adjuntar/1/${rootState.empresa.contratista}`, data)
            .then((response) => {
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Muy bien!',
                    text: response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                });
                dispatch('getImagen', {
                    companyId,
                    module: 'COMPANY'
                });
                state.error = false;
            })
            .catch((error) => {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Error',
                    text: error.data.message,
                    showConfirmButton: false,
                    timer: 2000
                });
            });
    }

}

export async function guardaAdjunto({commit, state, rootState, dispatch}, data) {

    var producto = rootState.productos.selectedProduct.id;

    if (producto == '') {
        producto = rootState.productos.selectedProduct.Idproducto;
    }

    if (state.selectedAdjunto.estado_fds == 162) {
        state.selectedAdjunto.cumple_decreto = 'SI';
    } else {
        state.selectedAdjunto.cumple_decreto = 'NO';
    }

    data.append('tipo', state.selectedAdjunto.tipo);
    data.append('fecha', state.selectedAdjunto.fecha);
    data.append('sistema', state.selectedAdjunto.sistema);
    data.append('activo', state.selectedAdjunto.activo);
    data.append('cumple_decreto', state.selectedAdjunto.cumple_decreto);
    data.append('idioma', state.selectedAdjunto.idioma);
    data.append('observacion', state.selectedAdjunto.observacion);

    await $http.post(`adm_productos/adjuntos/crear/${producto}`, data)
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: false,
                timer: 3000
            });
            commit('limpiarAdjunto');
            dispatch('getListadoAdj');
            state.error = false;
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
            reject(error);
        });
}

/**
 * @param  {} {commit
 * @param  {} state}
 * @param  {} query
 */
export async function getBases({commit, state}, query) {
    await $http.get('empresas/bases/2', {params: {nombre: query}})
        .then((response) => {
            commit('cargarBases', response.data.data);
            state.error = false;
        })
        .catch((error) => {
            commit('mensajeError', error.message);
        });
}

/**
 * @param  {} {commit
 * @param  {} state}
 * @param  {} query
 */
export async function descargarPlantillaUsuarios({commit, state}, query) {
    commit('dashboard/load', true, {root: true});
    await $http({
        url: 'usuarios/descargar-plantilla',
        method: 'POST',
        responseType: 'blob'
    })
        .then((response) => {
            window.downloadFile(response.data, 'usuarios_importable.xlsx')
            commit('dashboard/load', false, {root: true});
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: 'Error al obtener la plantilla',
                showConfirmButton: true,
                timer: 5000
            });
        });
}


/**
 * Método para agendar la descarga masiva de ajuntos.
 *
 * @export
 * @param {*} { commit, state}
 * @param {*} data
 */
export async function importarUsuarios({commit, state}, data) {
    commit('dashboard/load', true, {root: true});
    await $http.post(`empresas/procesamientos_background/USUARIOS-CARGA-MASIVA`, data)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            commit('establecerModalUsuario', false);
            await Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: false,
                timer: 3000
            });
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error.message + '<br >' + error.errors,
                showConfirmButton: false,
                timer: 2000
            });
        });
}

/**
 * Método para agendar la descarga masiva de ajuntos.
 *
 * @export
 * @param {*} { commit, state}
 * @param {*} data
 */
export async function listarImportesAgendados({commit, state}, data) {
    commit('dashboard/load', true, {root: true});
    await $http.get(`empresas/procesamientos_background/USUARIOS-CARGA-MASIVA/${data}`)
        .then((response) => {
            commit('setImportesProcesados', response.data.data);
            commit('dashboard/load', false, {root: true});
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error.message + '<br >' + error.errors,
                showConfirmButton: false,
                timer: 2000
            });
        });
}

/**
 * @param  {} {commit
 * @param  {} state}
 * @param  {} query
 */
export async function getAreas({commit, state}, query) {
    await $http.get('empresas/areas/2', {params: {nombre: query}})
        .then((response) => {
            commit('cargarAreas', response.data.data);
            state.error = false;
        })
        .catch((error) => {
            commit('mensajeError', error.message);
        });
}

export async function getPermisosPorRol({commit, state}, {id_rol, usuario}) {
    commit('dashboard/load', true, {root: true});
    if (usuario) {
        await $http.get(`permisos/roles/${id_rol}/${state.selectedUsuario.id}`)
            .then((response) => {
                commit('setPermisosRol', response.data);
                commit('dashboard/load', false, {root: true});
            })
            .catch((error) => {
                commit('dashboard/load', false, {root: true});
            });
    } else {
        commit('cambiaRolUsuario', id_rol);
        await $http.get(`roles/${id_rol}`)
            .then((response) => {
                commit('setPermisosRol', response.data);
                commit('dashboard/load', false, {root: true});
            })
            .catch((error) => {
                commit('dashboard/load', false, {root: true});
            });
    }
}


export async function getPermisosFiltro({commit, state}, requestParameters = {params: state.buscaPermiso}) {
    if (validarPermisoComponente('asignar-permisos-roles')) {
    commit('dashboard/load', true, {root: true});

    await $http.get(`/permisos`, requestParameters)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setPermisos', response.data.data);
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
        });
    }
}

/**
 * Verifica si un usuario autenticado puede serignar permisos.
 *
 * @export
 * @param {*} { commit, state}
 */
export async function validatePermissionsAssignment({commit, state}) {
    commit('setAssingPermissions',validarPermisoComponente('asignar-permisos-roles'));
}

export async function guardaPermisosRol({commit, state}) {
    var data = {
        permisos: state.permisosSeleccionados.ids,
        rol: state.rolusuario.id,
        id_user: state.selectedUsuario.id
    };

    commit('dashboard/load', true, {root: true});

    await $http.post(`permisos/roles/asignar`, data)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            commit('setPermisosRoles', response.data);
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            commit('permisosError', error.message);
        });
}

export async function eliminaPermisosRol({commit, state, dispatch}) {

    commit('dashboard/load', true, {root: true});

    await $http.delete(`permisos/roles/permisos/${state.selectedUsuario.id}`)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            await dispatch('getPermisosPorRol', {id_rol: state.rolusuario.id});
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
        });
}

export async function obtieneEmpresa({state}) {
    return state.selectedEmpresa.id;
}

export async function sumarCantidadRpq({rootState, dispatch}) {

    var empresa = rootState.empresa.selectedEmpresa.id;
    var valores = rootState.empresa.selectedAsignacionRpq;

    //await $http.get(`empresas/rpq/cantidades/${generales}`, { productos: state.productos.data })
    await $http.post(`empresas/rpq/cantidades/${empresa}`, {cantidad: valores.valorSumar})
        .then((response) => {
            dispatch('cantidadSumaRpq');
        })
        .catch((error) => {

        });
}

export async function cantidadSumaRpq({rootState, commit}, id) {

    commit('dashboard/load', true, {root: true});
    var empresa = rootState.empresa.selectedEmpresa.id;

    await $http.get(`empresas/rpq/suma/${empresa}`)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('asignaSumaRpq', response.data);
            commit('restauraValorSumar');
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
        });
}

// filtro de paginacion
export function setPagePagination({commit, dispatch}, page) {
    commit('setPage', parseInt(page));
    dispatch('getUsuarios');
}

export function setPerPagePagination({commit, dispatch, state}, perPage) {
    commit('setPerPage', parseInt(perPage));
    dispatch('getUsuarios');
}

export async function getConexion({commit}, empresa) {
    if (!isNaN(empresa)) {
    commit('dashboard/load', true, {root: true});
    await $http.get(`companies/validate-connection/${empresa}`)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setconexion', response.data.data);
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
        });
    }
}

/**
 * Método para la paginacion de los productos químicos.
 *
 * @param {*} param0
 * @param {*} page contiene la pagina.
 */
export function setPagePaginationEmpresa({commit, dispatch, state}, page) {
    commit('setPageEmpresa', parseInt(page));
    dispatch('listarEmpresas');
}

/**
 * Método para listar las empresas
 *
 * @param state
 * @param commit
 * @param filtro
 * @returns {Promise<void>}
 * @author Jhon García
 */
export async function listarContratistas({state, commit, dispatch}) {

    let requestParameters = {
        params: {
            id_empresa: state.selectedEmpresa.id
        }
    };

    commit('dashboard/load', true, {root: true});

    await $http.get('/contratistas', requestParameters)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setContratistas', response.data.data);
            dispatch('filtrarContratistas');
        }).catch(error => {
            commit('dashboard/load', true, {root: true});
        });
}

export async function filtrarContratistas({state, commit}) {
    let filter = state.paramsContratista.filtro.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

    if (state.paramsContratista.asignadas) {
        state.contratistas_filtrados.contratistas = state.contratistas.filter(contratista => {
            let nombre = contratista.nombre.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
            return nombre.includes(filter) && contratista.checked;
        });
    } else {
        state.contratistas_filtrados.contratistas = state.contratistas.filter(contratista => {
            let nombre = contratista.nombre.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
            return nombre.includes(filter);
        });
    }
}

/**
 * Método para asignar o desasignar contratistas
 *
 * @param state
 * @param commit
 * @param getters
 * @param contratista
 * @returns {Promise<void>}
 */
export async function asignarContratistas({state, commit, getters, dispatch}, contratista) {

    contratista.id_empresa = state.selectedEmpresa.id;

    let enviar = true;
    let contratistaTemp = state.contratistas.find(c => c.id === contratista.id);

    if (contratistaTemp && !contratista.checked) {
        await Swal.fire({
            title: 'Eliminar la asignación',
            text: '¿Está seguro de eliminar la asignación de ' + contratistaTemp.nombre + ' como contratista ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, Eliminiar'
        }).then(async (result) => {
            enviar = result.value;
        });
    }

    if (enviar) {
        commit('dashboard/load', true, {root: true});
        await $http.post('/contratistas', contratista)
            .then((response) => {
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 1000
                });

            }).catch(error => console.log(error));
        commit('dashboard/load', false, {root: true});
    }

    dispatch('listarContratistas');
}

/**
 * listar las empresas
 * @param {*} param0
 * @param id
 */
export async function listarUbicacionesEmpresa({dispatch, state, rootState, commit}) {
    await dispatch('ubicacion/arbolUbicacionesEmpresa', state.selectedEmpresa.id, {root: true});
    commit('productos/setUbicacioneEmpresa', rootState.ubicacion.arbolUbicaciones, {root: true});
    await dispatch('location/arbolUbicacionesEmpresa', state.selectedEmpresa.id, {root: true});
    commit('productos/setArbolEmpresa', rootState.location.arbolUbicaciones, {root: true});

}

export async function obtenerLicenciaActiva({commit, rootState}) {
    commit('dashboard/load', true, {root: true});

    const id_empresa = rootState.empresa.selectedEmpresa.id;

    await $http.get(`empresas/licencias/activa/${id_empresa}`)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            commit('establecerLicencia', response.data.licencia);
            commit('establecerLicenciaActiva', true);
        })
        .catch(async (error) => {
            commit('establecerLicenciaActiva', false);
            commit('dashboard/load', false, {root: true});
        });
}

export async function fetchProviders({state, commit}) {

    commit('dashboard/load', true, {root: true});

    let params = {
        paginate: 0,
        only_selected: 1,
        company_id: state.selectedEmpresa.id
    };

    await $http.get('/providers', {params})
        .then((response) => {
            commit('setProviders', response.data.data);
        })
        .catch((error) => {
            this.$swal({
                position: 'center',
                icon: 'error',
                title: 'Error al cargar fabricantes: ' + error,
                showConfirmButton: false,
                timer: 1500
            });
        });

    commit('dashboard/load', false, {root: true});

}

/**
 * Método para consultar los usuarios internos MyS con rol Admin.
 *
 * @returns {Array} usuarios internos.
 */
export async function getUsuariosInternos({commit}) {

    commit('dashboard/load', true, {root: true});

    await $http.get('companies/get-users-internals')
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setListadoUsuarioInternos', response.data.data);
        }).catch((error) => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Método que descarga la plantilla para actualización de datos de empresas.
 *
 */
export async function descargarPlantillaActualizacionEmpresa({commit}) {
    commit('dashboard/load', true, {root: true});
    await $http.get('companies/download-update-template')
        .then((response) => {
           let linkTemporary = document.createElement("a");
                document.body.appendChild(linkTemporary);
                linkTemporary.setAttribute("type", "hidden");
                linkTemporary.href = `data:text/plain;base64,${response.data.data}`;
                linkTemporary.download = `plantilla-actualizacion-empresa.xlsx`;
                linkTemporary.click();
                document.body.removeChild(linkTemporary);
                commit('dashboard/load', false, {root: true});
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: 'Error al obtener la plantilla',
                showConfirmButton: true,
                timer: 5000
            });
        });
}

/**
 * Método para cargar la plantilla de actualización de datos de empresas.
 *
 */
export async function cargarPlantillaActualizacionEmpresa({commit}, data) {
    commit('dashboard/load', true, {root: true});
    return new Promise(async (resolve, reject) => {
        await $http.post('/companies/import-update-template', data)
            .then((response) => {
                commit('dashboard/load', false, {root: true});
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: response.data.message,
                    showConfirmButton: true,
                    timer: 5000
                });
                resolve()
            })
            .catch((error) => {
                reject(error)
                commit('dashboard/load', false, {root: true});
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Hubo un error!',
                    showConfirmButton: true,
                    timer: 5000
                });
            });
    });
}

/**
 * Actualizar los datos del usuario.
 *
 * @author Fernando Claros Garcia
 */
export async function updateUser({ commit, state, rootState, dispatch }) {
  commit('dashboard/load', true, { root: true });
  await $http.put(`users/${state.selectedUsuario.id}`, state.selectedUsuario)
    .then(async (response) => {

      await Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Muy bien!',
        text: response.data.message,
        showConfirmButton: false,
        timer: 2000
      });
      dispatch('getUsuarios', rootState.empresa.selectedEmpresa.id);

    })
    .catch((error) => {

      let hasErrorsOfValidation = false;
      try {

        if ('errors' in error && typeof error.errors === 'object') {

          let errorsText        = "<ul>";
          hasErrorsOfValidation = true;
          Object.values(error.errors).forEach(item => errorsText += `<li>${item}</li>`);
          errorsText            += "</ul>";

          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Error de validaciones.',
            html: errorsText,
            showConfirmButton: false
          });
        }

      } catch(e) {}

      // solo se muestra si no hay errores de validaciones
      if (!hasErrorsOfValidation) {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: error.message + '<br />' + error.errors,
          showConfirmButton: false,
          timer: 3000
        });
      }

    })
    .finally(() => commit('dashboard/load', false, { root: true }))
}

/**
 * Guardar los datos de la configuracion de repotes para el usuario.
 *
 * @author Fernando Claros Garcia
 */
export async function getFDSConfigsReportByUserId({ commit, state }) {

    commit('setDefaultDataFdsConfigsReportUser');
    commit('dashboard/load', true, { root: true });

    await $http.get(`users/fds-configs-report/${state.selectedEmpresa.id}/${state.selectedUsuario.id}`)
        .then(({ data: response }) => {
            if (response.statusCode === "SUCCESS") {

                const configData = {
                    ...response.payload,
                    locations: JSON.parse(response.payload.locations)
                }

                commit('setFdsConfigsReportUser', configData);
            }
        })
        .catch(() => {
            Swal.fire({
                position: 'center',
                icon: 'info',
                title: 'Configuración no cargada.',
                text: "No fue posible cargar la configuración del usuario.",
                showConfirmButton: true
            });
        })
        .finally(() => commit('dashboard/load', false, { root: true }))

}

/**
 * Guardar los datos de la configuracion de repotes para el usuario.
 *
 * @param {*} state: contiene la información del estado.
 * @param {*} dataconfig: payload con la información de configuración del usuario.
 * @author Fernando Claros Garcia
 */
export async function storeConfigsReport({ commit }, configData) {
    commit('dashboard/load', true, { root: true });
    await $http.post('users/store-changes/fds-configs-report', configData)
        .then(({data: response}) => {

            if (response.statusCode === "ERROR_VALIDATIONS") {

                let errorsText = "";
                try {
                    errorsText += "<ul>";
                    Object.values(response.payload).forEach(item => errorsText += `<li>${item}</li>`);
                    errorsText += "</ul>";
                } catch (e) { }

                Swal.fire({
                    position: 'center',
                    icon: 'info',
                    title: 'Error de validaciones.',
                    html: errorsText,
                    showConfirmButton: true
                });

            } else if (response.statusCode === "SUCCESS") {

                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Muy bien!',
                    text: response.message,
                    showConfirmButton: true
                });

                const configData = {
                    ...response.payload,
                    locations: JSON.parse(response.payload.locations)
                }

                commit('setFdsConfigsReportUser', configData);
            }

        })
        .catch((error) => {

            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error en el proceso.',
                text: error.message + '<br />' + error.errors,
                showConfirmButton: false,
                timer: 3000
            });

        })
        .finally(() => commit('dashboard/load', false, { root: true }))
}

/**
 * Guardar variable configurable de empresa por usuario.
 *
 * @param {*} state: contiene la información del estado.
 * @param {*} payload: payload con la información de configuración del usuario.
 * @author Fernando Claros Garcia
 */
export async function storeCompanyCountryUser({ commit }, payload) {
    commit('dashboard/load', true, { root: true });
    await $http.post('users/company-country-user', payload)
        .then(({ data: response, status }) => {

            // Recurso creado/actualizado
            if ([200, 201].includes(status)) {
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Variables configurables',
                    text: response.message,
                    showConfirmButton: true
                });
                return false;
            }

            Swal.fire({
                position: 'center',
                icon: 'info',
                title: 'Variables configurables',
                text: response.message,
                showConfirmButton: true
            });

        })
        .catch(error => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Variables configurables',
                text: error.message,
                showConfirmButton: true
            });
        })
        .finally(() => commit('dashboard/load', false, { root: true }));
}

/**
 * Obtener la variable configurable de empresa asignada al usuario.
 *
 * @param {*} state: contiene la información del estado.
 * @param {*} { companyId, userId }: payload con la información para cargar la data.
 * @author Fernando Claros Garcia
 */
export async function getCompanyCountryUser({ commit }, { companyId, userId }) {

    commit('setConfigVarUser', '');
    commit('dashboard/load', true, { root: true });

    await $http.get(`users/company-country-user/${companyId}/${userId}`)
        .then(({ data: response, status }) => {

            // Recurso creado/actualizado
            if (status === 200 && response.data)
                commit('setConfigVarUser', 'slq_company_country_id' in response.data ? response.data.slq_company_country_id : '');

        })
        .catch(error => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Variables configurables',
                text: error.message,
                showConfirmButton: true
            });
        })
        .finally(() => commit('dashboard/load', false, { root: true }));
}

/**
 * Consultar variables configurable solo asignadas a la empresa como tal (no asignadas a usuarios).
 *
 * @param {*} state: contiene la información del estado.
 * @param {*} companyId
 * @author Fernando Claros Garcia
 */
export async function getOnlyCompany({ commit }, companyId) {

    commit('setConfigVarCompany', []);
    commit('dashboard/load', true, { root: true });

    await $http.get(`companies-country/by-company/${companyId}`)
        .then(({ data: response, status }) => {

            // Recurso creado/actualizado
            if (status === 200 && response.data) commit('setConfigVarCompany', response.data);

        })
        .catch(error => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Variables configurables',
                text: error.message,
                showConfirmButton: true
            });
        })
        .finally(() => commit('dashboard/load', false, { root: true }));
}

/**
 * Inactiva la variable configurable de empresa.
 *
 * @param {*} state: contiene la información del estado.
 * @param {*} { companyId, configVarId }: datos para el proceso.
 * @author Fernando Claros Garcia
 */
export async function changeStatusCompanyConfigVar({ commit }, { companyId, configVarId }) {

    commit('dashboard/load', true, { root: true });

    await $http.put(`companies-country/by-company/${companyId}/${configVarId}`)
        .then(({ data: response, status }) => {

            // Recurso creado/actualizado
            if (status === 200) {
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Variables configurables',
                    text: response.message,
                    showConfirmButton: true
                });

                return false;
            }

            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Variables configurables',
                text: response.message,
                showConfirmButton: true
            });

        })
        .catch(error => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Variables configurables',
                text: error.message,
                showConfirmButton: true
            });
        })
        .finally(() => commit('dashboard/load', false, { root: true }));
}

/**
 * Obtener configuración de Microsoft azure por empresa id.
 *
 * @param {*} commit
 * @param {*} company: empresa.
 * @author Fernando Claros Garcia
 */
export async function getConfigAzureByCompanyId({ commit }, company) {

    commit('dashboard/load', true, { root: true });

    const companyId = parseInt(company.id);
    if (!companyId) return

    await $http.get(`companies/microsoft.online/azure-config/${companyId}`)
        .then(({ data: response }) => {

            if (!response.data || typeof response.data !== 'object') return false;

            const { client_id, secret_value, tenant_id } = response.data

            commit('setDatosEmpresa', { ...company, client_id, secret_value, tenant_id });
            commit('home/establecerEmpresa', { ...company, client_id, secret_value, tenant_id }, {root: true});
        })
        .catch(error => {
            if (this.$vue.$alertErrorsCallback(error)) return;
            this.$vue.$alertError(error.message);
        })
        .finally(() => commit('dashboard/load', false, { root: true }));
}


/**
 * Obtener cantidades de productos de una empresa de los diferentes estados
 * (Verificados, Caracterizado, Te generadas, Te adjunto, Uso, Desuso y Aprobados).
 * @autor Paul Valencia
 */
export async function getProductSumByStatus({commit},company_id) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get(`products-rpq/product-sum-by-status/${company_id}`)
        commit('setDiligenciados', response.data.data);
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}

/**
 * Obtener resumen productos.
 * (Verificados, Caracterizado, Te generadas, Te adjunto, Uso, Desuso y Aprobados).
 * @autor Paul Valencia
 */
export async function getProductSummaryCompleted({commit},company_id) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get(`products-rpq/summary-completed/${company_id}`)
        commit('setSummary', response.data.data);
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}

/**
 * Marcar lista de chequeo de la empresa para el dashboard.
 *
 * @param {*} commit
 * @param {*} payload {company_id, checklist_id}
 *
 * @autor Paul Valencia
 */
export async function setChecklistCompany({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        await $http.post(`checklist-company/checklist-dashboard`,
            payload
        )
        commit('dashboard/load', false, {root: true});

        this.$vue.$alertSuccess('Se ha marcado la lista de chequeo correctamente.');

    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}

/* Obtener la empresa validando si el usuario pertence a ella o es Admin.
 *
 * @param {*} commit : contiene la información del commit.
 * @param {*} state : contiene la información del estado.
 * @param {integer} id : id de la empresa.
 */
export async function showValidateCompany({commit, state}, id) {
    if (!isNaN(id)) {
        commit('dashboard/load', true, {root: true});
        await $http.get(`/companies/show-validate/${id}`)
            .then((response) => {
                commit('setDatosEmpresa', response.data.data);
                commit('home/establecerEmpresa', response.data.data, {root: true});
                state.error = false;
                return response.data.data;
            })
            .catch((error) => {
                commit('empresaDatosError', error.message);
            }).finally(() => commit('dashboard/load', false, {root: true}));
        }
}
